"use strict";
/**
 * @file Created on 29/08/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * FindWindowProductsDTOConverter
 *
 * @author Tomáš Leity
 */


var FindWindowProductsDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(FindWindowProductsDTOConverter, _DataObjectConverter_);

  function FindWindowProductsDTOConverter() {
    _classCallCheck(this, FindWindowProductsDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(FindWindowProductsDTOConverter).apply(this, arguments));
  }

  return FindWindowProductsDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.FindWindowProductsDTOConverter = FindWindowProductsDTOConverter;